// extracted by mini-css-extract-plugin
export default {"dropdownFilter":"DropdownFilter_dropdownFilter__e69gs","labelText":"DropdownFilter_labelText__hgHHj","dropdownInput":"DropdownFilter_dropdownInput__pyAZb"};